import { Icon } from "components/icon";
import React from "react";

export const AdditionalContactsHeader: React.FC = () => (
    <div className="flex items-center space-x-2">
        <div className="w-7 mt-0.5">
            <Icon name="46_MoreContacts" />
        </div>
        <p className="text-lg text-gray-700">Additional Contacts</p>
    </div>
);
